import { render, staticRenderFns } from "./Registrars.vue?vue&type=template&id=214068b9&"
import script from "./Registrars.vue?vue&type=script&lang=js&"
export * from "./Registrars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports